const PageDictionary = () => import(/* webpackChunkName: "page-dictionary" */ '@/modules/dictionary/PageDictionary')
const ColumnsManagerList = () => import('@/modules/columnsmanager/firstcolumns/ColumnsManagerList')
const SecondColumnsManager = () => import('@/modules/columnsmanager/secondcolumns/SecondColumnsManager')
const SensitiveManager = () => import('@/modules/sensitive/SensitiveManager')
const customBtn = () => import('@/modules/custombtn/CustomBtnMgt')

export default [
  {
    path: '/dictionary',
    name: 'dictionary',
    component: PageDictionary,
    meta: {
      title: '数据字典',
      isBlack: true
    },
  },

  {
    path: '/admin/dictionary',
    name: 'admin_dictionary',
    component: PageDictionary,
    meta: {
      title: '数据字典(管理员)',
      isBlack: true
    },
    props: {
      admin: true,
    }
  },
  {
    path: '/fwsc/dictionary/:optId',
    name: 'fwsc_dictionary',
    component: PageDictionary,
    meta: {
      title: '数据字典(服务商城)',
      isBlack: true
    },
    props: {
      admin: true,
    }
  },
  {
    path: '/Sensitive',
    name: 'Sensitive',
    component: SensitiveManager,
    meta: {
      title: '敏感词汇管理',
    },
  },
  {
    path: '/firstcolumns',
    name: 'firstcolumns',
    component: ColumnsManagerList,
    meta: {
      title: '一级栏目管理',
      isBlack: true
    },
  },
  {
    path: '/secondcolumns',
    name: 'secondcolumns',
    component: SecondColumnsManager,
    meta: {
      title: '二级栏目管理',
      isBlack: true
    },
  },
  {
    path: '/customBtn',
    name: 'customBtn',
    component: customBtn,
    meta: {
      title: '自定义按钮管理',
      isBlack: true
    },
  },
]
